import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { DsIconGlyph } from '@/ds/icon'
import { DsIcons } from '@/ds/icons'

export interface DsBreadcrumb {
  label: string
  /** Omit for the current page (the last crumb). */
  to?: string
}

/** Desktop only; phones rely on the back button. */
export function DsBreadcrumbs({ items, className }: { items: DsBreadcrumb[]; className?: string }) {
  if (items.length === 0) return null
  return (
    <nav aria-label="Breadcrumb" className={cn('hidden min-w-0 lg:block', className)}>
      <ol className="flex min-w-0 items-center gap-1 text-small text-muted-foreground">
        {items.map((c, i) => {
          const last = i === items.length - 1
          return (
            <Fragment key={`${c.label}-${i}`}>
              {i > 0 && (
                <li aria-hidden className="shrink-0">
                  <DsIconGlyph icon={DsIcons.chevronRight} size={14} />
                </li>
              )}
              <li className={cn('min-w-0', last ? 'truncate text-foreground' : 'shrink-0')}>
                {c.to && !last ? (
                  <Link to={c.to} className="rounded outline-none hover:text-foreground hover:underline focus-visible:ring-focus">
                    {c.label}
                  </Link>
                ) : (
                  <span aria-current={last ? 'page' : undefined}>{c.label}</span>
                )}
              </li>
            </Fragment>
          )
        })}
      </ol>
    </nav>
  )
}
